import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import * as _ from "lodash";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { ServiceRequestService } from "src/app/modules/service-request/service-request.service";
import { Alert } from "src/app/shared/class/Alert";
import { UserService } from "src/app/shared/components/user/user.service";
import { globalConst } from "src/app/shared/helpers/constants";
import { Helper } from "src/app/shared/helpers/helper";
import { Agent } from "src/app/shared/models/agent.model";
import { Company } from "src/app/shared/models/company";
import {
  GroupedInventory,
  Inventory,
} from "src/app/shared/models/inventory.model";
import { QueryParams } from "src/app/shared/models/query-params";
import { Regional } from "src/app/shared/models/regional";
import { ServiceLocal } from "src/app/shared/models/service-request.model";
import { User } from "src/app/shared/models/user.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { ReportService } from "../../report.service";
import { ReportImageDialogComponent } from "../report-image-dialog/report-image-dialog.component";
import { InvetoryTypePipe } from "./../../../../shared/pipe/invetory-type.pipe";
import { ExcelService } from "./../../../../shared/services/excel.service";
moment.locale("pt-br");

export interface EtaIndicators {
  totalEtas?: string;
  totalInventoried?: string;
}
@Component({
  selector: "app-report-inventory",
  templateUrl: "./report-inventory.component.html",
  styleUrls: ["./report-inventory.component.scss"],
})
export class ReportInventoryComponent implements OnInit {
  goback = "";

  userLogged: User = {};
  form: FormGroup;
  startDate = new FormControl();
  minStartDate = new Date();
  strStartDate = "";
  endDate = new FormControl();
  minEndDate = null;
  strEndDate = "";
  agentOptions: Agent[] = [];
  filteredAgentOptions: Agent[] = [];

  groupedInventory: GroupedInventory[] = [];
  etaInventoried: Inventory[] = [];
  loaded = false;
  itemsPerPage = 30;
  currentPage = 1;
  itemsPerPageEta = 30;
  currentPageEta = 1;

  etaIndicators: EtaIndicators = {};
  invetoryIndicators: EtaIndicators = {};

  serviceLocalOptions: ServiceLocal[] = [];

  selectedCompany: Company = {};
  optionsCompany: Company[] = [];
  filteredOptionsCompany: Company[] = this.optionsCompany;

  selectedRegional: Regional = {};
  optionsRegional: Regional[] = [];
  filteredOptionsRegional: Regional[] = this.optionsRegional;

  selectedServiceLocal: ServiceLocal = {};
  optionsServiceLocal: ServiceLocal[] = [];
  filteredOptionsServiceLocal: ServiceLocal[] = this.optionsServiceLocal;

  @ViewChild("tabGroup", { static: false }) tabGroup;

  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private reportService: ReportService,
    private serviceRequestService: ServiceRequestService,
    private userService: UserService,
    private fb: FormBuilder,
    private excelService: ExcelService,
    private invetoryTypePipe: InvetoryTypePipe,
    private router: Router,
    public dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.loadForm();
    this.userLogged = this.authService.getUserLogged();
    const userData = await this.userService.searchUser(this.userLogged.id);
    if (userData.type === globalConst.defaults.user.client) {
      this.router.navigate(["/home"]);
    } else {
      try {
        // this.spinner.show();
        await this.loadCompanyOptions();
        await this.loadRegionalOptions();
        await this.loadServiceLocalOptions();
        this.loadTabData();
      } catch (error) {
        this.spinner.hide();
      }
    }
  }

  private loadForm() {
    this.form = new FormGroup({
      startDate: new FormControl("" as string),
      endDate: new FormControl("" as string),
      company: new FormControl("T"),
      regional: new FormControl(null as number),
      serviceLocal: new FormControl(null as number),
      agent: this.fb.control(""),
      bem: this.fb.control(""),
      plaqueta: this.fb.control(""),
    });
  }

  async loadCompanyOptions() {
    try {
      this.optionsCompany.push({ id: 0, description: "Aguarde Carregando..." });
      this.filteredOptionsCompany = this.optionsCompany;
      this.selectedCompany = this.filteredOptionsCompany.find(
        (obj) => obj.id == 0
      );
      this.form.controls.company.setValue(this.selectedCompany);

      const data: any = await this.serviceRequestService.getCompanies();
      this.optionsCompany =
        this.authService.getUserLogged().type ===
        globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.authService.getUserLogged().companiesAssociate;
      this.optionsCompany.push({ id: 0, description: "TODOS" });
      this.filteredOptionsCompany = this.optionsCompany;
      this.selectedCompany = this.filteredOptionsCompany.find(
        (obj) => obj.id == 0
      );
      this.form.controls.company.setValue(this.selectedCompany);

      if (!this.optionsCompany.length) {
        Alert.warning(Alert.getMessage().errors.company.emptySearch);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async loadRegionalOptions() {
    try {
      this.optionsRegional = [];
      this.optionsRegional.push({
        id: 0,
        description: "Aguarde Carregando...",
      });
      this.filteredOptionsRegional = this.optionsRegional;
      this.selectedRegional = this.filteredOptionsRegional.find(
        (obj) => obj.id == 0
      );
      this.form.controls.regional.setValue(this.selectedRegional);

      //
      const data: any = await this.serviceRequestService.getRegionals();
      this.optionsRegional =
        this.authService.getUserLogged().type ===
        globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.authService.getUserLogged().regionalsAssociate;

      //
      if (this.selectedCompany.id > 0) {
        this.optionsRegional = this.optionsRegional.filter(
          (obj) =>
            obj.companyAlternativeIdentifier ===
            this.selectedCompany.alternativeIdentifier
        );
      }

      this.optionsRegional.push({ id: 0, description: "TODAS" });
      this.filteredOptionsRegional = this.optionsRegional;
      this.selectedRegional = { id: 0, description: "TODAS" };
      this.form.controls.regional.setValue(this.selectedRegional);
    } catch (error) {
      console.error(error);
    }
  }

  async loadServiceLocalOptions() {
    try {
      this.optionsServiceLocal = [];
      this.optionsServiceLocal.push({
        id: 0,
        description: "Aguarde Carregando...",
      });
      this.filteredOptionsServiceLocal = this.optionsServiceLocal;
      this.selectedServiceLocal = this.filteredOptionsServiceLocal.find(
        (obj) => obj.id == 0
      );
      this.form.controls.serviceLocal.setValue(this.selectedServiceLocal);

      const data: any = await this.serviceRequestService.getServiceLocals();
      this.optionsServiceLocal =
        this.authService.getUserLogged().type ===
        globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.authService.getUserLogged().serviceLocalsAssociate;

      if (this.selectedRegional.id == 0) {
        const auxServiceLocal = [];
        this.form.controls.serviceLocal.setValue(null);
        this.optionsRegional.map((regional) => {
          // tslint:disable-next-line: max-line-length
          this.optionsServiceLocal
            .filter((obj) => obj.regionalId === regional.id)
            .map((serviceLocal) => auxServiceLocal.push(serviceLocal));
        });
        this.optionsServiceLocal = auxServiceLocal;
      } else {
        this.optionsServiceLocal = this.optionsServiceLocal.filter(
          (obj) => obj.regionalId === this.selectedRegional.id
        );
      }

      this.optionsServiceLocal.push({ id: 0, description: "TODAS" });
      this.filteredOptionsServiceLocal = this.optionsServiceLocal;
      this.selectedServiceLocal = { id: 0, description: "TODAS" };
      this.form.controls.serviceLocal.setValue(this.selectedServiceLocal);
    } catch (error) {
      console.error(error);
    }
  }

  async changeCompany() {
    try {
      this.spinner.show();
      await this.loadRegionalOptions();
      await this.loadServiceLocalOptions();
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      Helper.handleError(error);
    }
  }

  async changeServiceLocal() {
    const control = this.form.controls.serviceLocal;
    if (!_.isNull(control.value) && control.value !== "0") {
      this.selectedRegional = this.optionsRegional.find(
        (obj) => obj.id === control.value.regionalId
      );
      this.form.controls.regional.setValue(this.selectedRegional);

      this.selectedCompany = this.filteredOptionsCompany.find(
        (obj) =>
          obj.alternativeIdentifier ==
          this.selectedRegional.companyAlternativeIdentifier
      );
      this.form.controls.company.setValue(this.selectedCompany);
    }
  }

  async onSubmit() {
    if (this.validateForm()) {
      this.spinner.show();
      this.loaded = false;
      this.currentPage = 1;
      const data: any = await this.reportService.getInventory(
        this.getQueryParams()
      );
      this.loaded = true;
      this.groupedInventory = [];

      //O campo status só vem preenchido quando há algum erro
      if (_.isUndefined(data.status)) {
        let lastTask = "";
        _.map(data, async (inventory) => {
          if (inventory.tarefa !== lastTask) {
            //Uma Nova tarefa
            this.groupedInventory.push({
              ...inventory,
              tipo: 1,
              descricao: "",
              tipo_detalhe: "",
              // intermediarios: [],
              // complementares: [],
            });
          } else {
            let taskFounded = this.groupedInventory.find(
              (obj) => obj.tarefa === inventory.tarefa
            );

            this.groupedInventory.push({
              ...inventory,
              bem: taskFounded.bem,
              tipo: !_.isNull(inventory.intermediario)
                ? 2
                : !_.isNull(inventory.complementar)
                ? 3
                : 1,
              tipo_detalhe: !_.isNull(inventory.intermediario)
                ? inventory.intermediario
                : !_.isNull(inventory.complementar)
                ? inventory.complementar
                : "",
            });
          }
          lastTask = inventory.tarefa;
        });
      }

      this.loadTabData();
      this.spinner.hide();
    } else {
      this.spinner.hide();
      this.loaded = false;
      Alert.warning(Alert.getMessage().errors.requiredFilters);
    }
  }

  getQueryParams() {
    const params: QueryParams[] = [];
    const filters = this.form.controls;

    if (!_.isNull(filters.company.value) && filters.company.value.id > 0) {
      params.push({
        id: "company",
        value: filters.company.value.id,
      });
    }

    /* if (!_.isNull(filters.startDate.value) && filters.startDate.value !== "") {
      params.push({
        id: "startDate",
        value: moment(filters.startDate.value).format("YYYY-MM-DD"),
      });
    }

    if (!_.isNull(filters.endDate.value) && filters.endDate.value !== "") {
      params.push({
        id: "endDate",
        value: moment(filters.endDate.value).format("YYYY-MM-DD"),
      });
    } */

    if (!_.isNull(this.selectedRegional) && this.selectedRegional.id > 0) {
      params.push({ id: "regional", value: this.selectedRegional.id });
    }

    console.log(this.selectedServiceLocal);
    if (
      !_.isNull(this.selectedServiceLocal) &&
      this.selectedServiceLocal.id > 0
    ) {
      params.push({ id: "serviceLocal", value: this.selectedServiceLocal.id });
    }

    if (!_.isEmpty(filters.bem.value) && filters.bem.value != "") {
      params.push({ id: "bem", value: filters.bem.value });
    }

    if (!_.isEmpty(filters.plaqueta.value) && filters.plaqueta.value != "") {
      params.push({ id: "plaqueta", value: filters.plaqueta.value });
    }

    return this.prepareQueryParams(params);
  }

  prepareQueryParams(params: QueryParams[]) {
    let queryParams = "";
    params.map((param) => {
      queryParams = queryParams === "" ? "" : `${queryParams}&`;
      queryParams = `${queryParams}${param.id}=${param.value}`;
    });
    return queryParams;
  }

  validateForm() {
    if (
      /* this.form.controls.startDate.value !== "" ||
      this.form.controls.endDate.value !== "" ||
      this.form.controls.agent.value !== "" */
      !_.isNull(this.form.controls.company.value) ||
      !_.isNull(this.form.controls.regional.value) ||
      !_.isNull(this.form.controls.serviceLocal.value) ||
      this.form.controls.bem.value !== "" ||
      this.form.controls.plaqueta.value !== ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  exportExcel() {
    this.excelService.exportAsExcelFile(
      this.getExcelData(this.groupedInventory),
      "inventario"
    );
  }

  getExcelData = (inventory) => {
    const jsonData = [];
    _.map(inventory, (data) => {
      jsonData.push({
        CLIENTE: data.empresa,
        REGIONAL: data.regional,
        ETA: data.eta,
        DATA: data.data_ref,
        TECNICO: data.tecnico,
        BEM: data.bem,
        IMAGEM: data.e_fotobem,
        TIPO: this.invetoryTypePipe.transform(data.tipo),
        DETALHE: data.tipo_detalhe,
        ITEM: data.descricao,
        QUANTIDADE: data.e_qtd,
        OBSERVACAO: data.e_obs,
        PLAQUETA: data.e_plaqueta,
      });
    });
    return jsonData;
  };

  /**
   * @description Método que faz a consulta no momento de mudança de aba
   */
  async loadTabData() {
    if (this.validateForm()) {
      this.spinner.show();
      this.loaded = false;
      let data: any;
      switch (this.tabGroup.selectedIndex) {
        case 0:
          this.currentPage = 1;
          this.invetoryIndicators = {};
          this.groupedInventory = [];

          data = await this.reportService.getInventory(this.getQueryParams());

          //O campo status só vem preenchido quando há algum erro
          if (_.isUndefined(data.status)) {
            let lastTask: any = "";
            let lastAsset: any = "";

            _.map(data, async (inventory) => {
              if (inventory.tarefa !== lastTask.tarefa) {
                //Uma Nova tarefa
                this.groupedInventory.push({
                  ...inventory,
                  tipo: 1,
                  descricao: "",
                  tipo_detalhe: "",
                });
              } else {
                let taskFounded = this.groupedInventory.find(
                  (obj) => obj.tarefa === inventory.tarefa
                );

                if (
                  inventory.bem !== null ||
                  lastTask.bem !== null ||
                  lastAsset === ""
                ) {
                  lastAsset =
                    inventory.bem !== null ? inventory.bem : lastTask.bem;
                }

                this.groupedInventory.push({
                  ...inventory,
                  bem: lastAsset,
                  tipo: !_.isNull(inventory.intermediario)
                    ? 2
                    : !_.isNull(inventory.complementar)
                    ? 3
                    : 1,
                  tipo_detalhe: !_.isNull(inventory.intermediario)
                    ? inventory.intermediario
                    : !_.isNull(inventory.complementar)
                    ? inventory.complementar
                    : "",
                });
              }
              lastTask = inventory;
            });
          }

          this.invetoryIndicators =
            await this.reportService.getInventoryIndicators(
              this.getQueryParams()
            );

          break;
        case 1: //Listando as Etas Inventariadas
          this.currentPageEta = 1;
          this.etaIndicators = {};
          this.etaInventoried = [];

          data = await this.reportService.getEta(this.getQueryParams());
          if (_.isUndefined(data.status)) {
            data.sort((a: Inventory, b: Inventory) =>
              a.empresa < b.empresa ? -1 : 1
            );

            this.etaInventoried = data;
          }

          this.etaIndicators = await this.reportService.getEtaIndicators(
            this.getQueryParams()
          );
          break;
        default:
          break;
      }

      this.loaded = true;
      this.spinner.hide();
    } else {
      this.loaded = false;
      this.spinner.hide();
      Alert.warning(Alert.getMessage().errors.requiredFilters);
    }
  }

  exportEtaExcel() {
    this.excelService.exportAsExcelFile(
      this.getEtaExcelData(this.etaInventoried),
      "eta"
    );
  }

  getEtaExcelData = (inventory) => {
    const jsonData = [];
    _.map(inventory, (data) => {
      jsonData.push({
        CLIENTE: data.empresa,
        REGIONAL: data.regional,
        ETA: data.eta,
        DATA: data.data_ref,
        TECNICO: data.tecnico,
      });
    });

    return jsonData;
  };

  openImage(fotoBem: string) {
    this.dialog.open(ReportImageDialogComponent, {
      data: { imagePath: fotoBem },
    });
  }

  /** */
  filterOptionsCompany(value?: string) {
    value = value.trim();
    this.filteredOptionsCompany = value
      ? this._filterCompany(value)
      : this.optionsCompany.slice();
  }

  private _filterCompany(value: string): Company[] {
    const filterValue = value.toLowerCase();
    const searchName = this.optionsCompany.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
    if (searchName.length) {
      return searchName;
    }

    return this.optionsCompany.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
  }

  displayCompany(item?: Company): string {
    return !_.isNull(item) ? item.description : "";
  }

  checkSelectedCompany(value?: string) {
    setTimeout(() => {
      value = value.trim();
      if (value && _.isUndefined(this.selectedCompany.id))
        Alert.warning("Selecione uma Empresa Válida!").then(() => {
          this.selectedCompany = null;
        });
    }, 250);
  }

  /** */
  filterOptionsRegional(value?: string) {
    value = value.trim();
    this.filteredOptionsRegional = value
      ? this._filterRegional(value)
      : this.optionsRegional.slice();
  }

  private _filterRegional(value: string): Regional[] {
    const filterValue = value.toLowerCase();
    const searchName = this.optionsRegional.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
    if (searchName.length) {
      return searchName;
    }

    return this.optionsRegional.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
  }

  displayRegional(item?: Regional): string {
    return !_.isNull(item) ? item.description : "";
  }

  checkSelectedRegional(value?: string) {
    setTimeout(() => {
      value = value.trim();
      if (value && _.isUndefined(this.selectedRegional.id))
        Alert.warning("Selecione uma Regional Válida!").then(() => {
          this.selectedRegional = null;
        });
    }, 250);
  }

  /** */
  filterOptionsServiceLocal(value?: string) {
    value = value.trim();
    this.filteredOptionsServiceLocal = value
      ? this._filterServiceLocal(value)
      : this.optionsServiceLocal.slice();
  }

  private _filterServiceLocal(value: string): ServiceLocal[] {
    const filterValue = value.toLowerCase();
    const searchName = this.optionsServiceLocal.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
    if (searchName.length) {
      return searchName;
    }

    return this.optionsServiceLocal.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
  }

  displayServiceLocal(item?: ServiceLocal): string {
    return !_.isNull(item) ? item.description : "";
  }

  checkSelectedServiceLocal(value?: string) {
    setTimeout(() => {
      value = value.trim();
      if (value && _.isUndefined(this.selectedServiceLocal.id))
        Alert.warning("Selecione uma Localidade Válida!").then(() => {
          this.selectedServiceLocal = null;
        });
    }, 250);
  }
}
